import React, {useEffect, useState} from 'react';
import Dashboard from '../../layout/Dashboard';
import {
  IconButton,
  Table,
  TableHead,
  TableRow,
  TableCell,
  CircularProgress,
  InputLabel,
  Select,
  MenuItem,
  Grid,
} from '@material-ui/core';
import AddIcon from '@material-ui/icons/Add';
import {read, utils, writeFile} from 'xlsx';

import UploadIcon from '@material-ui/icons/CloudUpload';
import useStyles from './styles';
import ButtonSubmit from '../../components/forms/ButtonSubmit';

import {CloudDownload, Edit, Save} from '@material-ui/icons';
import EditListBusinessItem from './editList';
import Business from '../../models/Business';
import {useSnackbar} from 'notistack';
import api from '../../core/api';
import Confirm from '../../components/Confirm';
import ShowSubmitError from '../../components/ShowSubmitError';
import {GetData} from '../../utils/Storage';
import {validateEmail} from '../../utils/validateEmail';

const ListBusinessUsersPage = ({history}) => {
  const classes = useStyles();
  const {enqueueSnackbar} = useSnackbar();
  const [isLoading, setIsLoading] = useState(false);
  const [editable, setEditable] = useState(false);
  const [users, setUsers] = useState([]);
  const [getEmpresas, setEmpresas] = useState([]);
  const [getPlans, setPlans] = useState([]);
  const [selectEmpresa, setSelectEmpresa] = useState('');
  const [selectBeneficiaryType, setBeneficiaryType] = useState('');
  const [selectPremium, setPremium] = useState('');

  const user = GetData('business');

  const fetchEmpresa = async () => {
    try {
      const allEmpresas = await Business.findAll();
      setEmpresas(allEmpresas);
    } catch (e) {
      // console.log({e});
    }
  };

  useEffect(() => {
    fetchEmpresa();

    if (!user.adminMaster) {
      setSelectEmpresa(user.business_id);
    }
  }, []);

  const handleImport = $event => {
    const files = $event.target.files;
    if (files.length) {
      const file = files[0];
      const reader = new FileReader();
      reader.onload = async event => {
        const wb = read(event.target.result);
        const sheets = wb.SheetNames;

        if (sheets.length) {
          const rows = utils.sheet_to_json(wb.Sheets[sheets[0]], {range: 2});
          console.log('rows', rows);
          setUsers(rows);
          // verificarDuplicados();
        }
      };
      reader.readAsArrayBuffer(file);
    }
  };

  const handleExport = () => {
    const link = document.createElement('a');
    link.href = '/Modelo_de_upload.xlsx';
    link.download = 'Modelo de upload (usuários B2B).xlsx';
    link.click();
  };

  async function onSubmit() {
    if (editable) {
      setEditable(false);
      return;
    }
    if (!selectEmpresa) {
      enqueueSnackbar('Selecione uma empresa.', {
        variant: 'error',
      });
      return;
    }
    if (!selectPremium) {
      enqueueSnackbar('Selecione o Plano.', {
        variant: 'error',
      });
      return;
    }
    if (!selectBeneficiaryType) {
      enqueueSnackbar('Selecione o Tipo de beneficiados.', {
        variant: 'error',
      });
      return;
    }

    let statusOk = true;
    const payload = users.map(user => {
      const stringfiedPhone = user.Telefone ? user.Telefone.toString() : ''
      if (statusOk) {
        if (!user['E-mail']) {
          enqueueSnackbar('Campo email não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        if (!validateEmail(user['E-mail'])) {
          enqueueSnackbar(`Email ${user['E-mail']} inválido.`, {
            variant: 'error',
          });
          statusOk = false;
          return;
        }
        if (!user.Nome) {
          enqueueSnackbar('Campo nome não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }
    
    
        if (!user['Senha (Temporária)']) {
          enqueueSnackbar('Campo Senha não pode ser nulo.', {
            variant: 'error',
          });
          statusOk = false;
          return;
        }

        return {
          email: user['E-mail'].trim(),
          name: user.Nome,
          departament: user.Departamento,
          phone: stringfiedPhone,
          password: user['Senha (Temporária)'],
          business_id: selectEmpresa,
          business_user: true,
          premium: selectPremium,
          registration_platform: 'Empresa',
          beneficiary_type: selectBeneficiaryType,
          is_active: true,
        };
      }
    });

    if (statusOk) {
      // console.log(payload);
      const res = await Confirm('Deseja realmente salvar esses usuários?');

      if (res) {
        setIsLoading(true);
        try {
          await api.post(`/business_users/mult`, payload).then(res => {
            // console.log(res);
            if (res.status === 200) {
              enqueueSnackbar('Usuários inseridos com sucesso!');
              history.push('/usuarios-empresa');
            }
          });
        } catch (error) {
          if (error.response) {
            // Erro retornado pela API
            if (
              error.response.status === 409 &&
              error.response?.data?.payload?.existingEmails
            ) {
              const emails = error.response?.data?.payload?.existingEmails;
              await ShowSubmitError(emails);
            } else {
              enqueueSnackbar(
                error.response?.data?.payload?.message ||
                  'Ocorreu um erro de requisição, tente novamente!',
              );
              console.log('Erro na requisição:', error.response.status);
            }
          } else if (error.request) {
            enqueueSnackbar('Sem resposta do servidor, tente novamente!');
          } else {
            enqueueSnackbar(
              'Erro na configuração da requisição, tente novamente!',
            );
          }
        } finally {
          setIsLoading(false);
        }
      }
    }
  }

  async function fetchPlans() {
    if (selectEmpresa) {
      try {
        const {data} = await api.get(`/business_commercial/${selectEmpresa}`);
        setPlans(data);
        if (data.length <= 0) enqueueSnackbar('Não há planos ativos.');
      } catch (e) {}
    }
  }

  useEffect(() => {
    fetchPlans();
  }, [selectEmpresa]);

  return (
    <Dashboard>
      <div className={classes.uploadsScreen}>
        <div className={classes.titleContainer}>
          <div className={classes.uploadBar}>
            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
              }}>
              <InputLabel>Baixar modelo da lista de usuários</InputLabel>
              <IconButton
                variant="contained"
                component="label"
                onClick={handleExport}>
                <CloudDownload />
              </IconButton>
            </div>

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 20,
              }}>
              <InputLabel>Subir excel</InputLabel>
              <IconButton variant="contained" component="label">
                <UploadIcon />
                <input
                  type="file"
                  className={classes.fileInput}
                  required
                  onChange={handleImport}
                  accept=".csv, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                />
              </IconButton>
            </div>

            {users.length ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  paddingLeft: 20,
                }}>
                <InputLabel>{`${
                  editable ? 'Ver' : 'Editar'
                } campos`}</InputLabel>
                <IconButton
                  variant="contained"
                  component="label"
                  onClick={() => setEditable(!editable)}>
                  {editable ? <Save /> : <Edit />}
                </IconButton>
              </div>
            ) : null}

            <div
              style={{
                display: 'flex',
                flexDirection: 'column',
                paddingLeft: 20,
              }}>
              <InputLabel>Adicionar novo usuário</InputLabel>
              <IconButton
                variant="contained"
                component="label"
                onClick={() => {
                  const newUser = [
                    ...users,
                    {
                      'E-mail': '',
                      Nome: '',
                      Departamento: '',
                      Telefone: '',
                      'Senha (Temporária)': '',
                    },
                  ];
                  setUsers(newUser);
                  setEditable(true);
                }}>
                <AddIcon />
              </IconButton>
            </div>
          </div>

          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
              width: '200px',
              height: '100px',
              marginRight: 50,
            }}>
            <InputLabel>Selecione a empresa</InputLabel>

            <Select
              variant="outlined"
              value={selectEmpresa}
              label="Selecione a empresa"
              disabled={!user.adminMaster}
              onChange={e => setSelectEmpresa(e.target.value)}>
              {getEmpresas &&
                getEmpresas.map(e => {
                  return <MenuItem value={e.id}>{e.corporateName}</MenuItem>;
                })}
            </Select>
          </div>

          {users.length ? (
            <div className={classes.uploadBar}>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '200px',
                  height: '100px',
                  marginRight: 50,
                }}>
                <InputLabel>Plano</InputLabel>

                <Select
                  variant="outlined"
                  disabled={!selectEmpresa || !getPlans.length}
                  value={selectPremium}
                  placeholder="Selecione o Plano"
                  onChange={e => setPremium(e.target.value)}>
                  {getPlans &&
                    getPlans.map(e => {
                      return <MenuItem value={e.id}>{e.title}</MenuItem>;
                    })}
                </Select>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  width: '200px',
                  height: '100px',
                  marginRight: 50,
                }}>
                <InputLabel>Tipo de beneficiado</InputLabel>

                <Select
                  variant="outlined"
                  value={selectBeneficiaryType}
                  label="Tipo de beneficiado"
                  onChange={e => setBeneficiaryType(e.target.value)}>
                  {[
                    'Geral',
                    'Colaboradores',
                    'Clientes',
                    'Gift/brindes/sorteio',
                    'Doações',
                    'Outros',
                  ].map(option => (
                    <MenuItem key={option} value={option}>
                      {option}
                    </MenuItem>
                  ))}
                </Select>
              </div>
            </div>
          ) : null}
        </div>

        <div className={classes.mediaItems}>
          {!isLoading ? (
            <>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell></TableCell>
                    <TableCell>Email</TableCell>
                    <TableCell>Nome</TableCell>
                    <TableCell>Departamento</TableCell>
                    <TableCell>Telefone</TableCell>
                    <TableCell>Senha (Temporária)</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                {users && users.length > 0 && (
                  <EditListBusinessItem
                    users={users}
                    editable={editable}
                    setUsers={setUsers}
                  />
                )}
              </Table>
              {users.length ? (
                <ButtonSubmit
                  loadingArea={isLoading}
                  style={{marginTop: 20}}
                  type="button"
                  fullWidth
                  variant="contained"
                  color="primary"
                  onClick={onSubmit}>
                  Salvar
                </ButtonSubmit>
              ) : null}
            </>
          ) : (
            <div
              className="flex-col center-a center-b"
              style={{height: '50vh'}}>
              <span style={{paddingTop: '10em', justifyContent: 'center'}}>
                <CircularProgress size={100} />
                <p> Salvando dados... </p>
              </span>
            </div>
          )}
        </div>
      </div>
    </Dashboard>
  );
};

export default ListBusinessUsersPage;
